import { useState } from 'react';

export const usePhoneMask = (initial = '') => {
  const [operatorPhone, setOperatorPhone] = useState(initial);

  const phoneDisplay = operatorPhone;

  const handlePhoneChange = (value: string) => {
    const digitsOnly = value.replace(/\D/g, '');
    setOperatorPhone(digitsOnly);
  };

  return {
    operatorPhone,
    setOperatorPhone,
    phoneDisplay,
    handlePhoneChange,
  };
};
